import { useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { notification } from "antd";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from 'react-router-dom';
import { ConnectorService } from '../../../base/service/apiServices';
import { LocalStorage } from '../../../custom_hooks/localStorageKeys';
import { GetItemFromStorage } from '../../../custom_hooks/useStorage';
import _ from 'lodash';

const WixStoreCheck = () => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const wix_shop: any = searchParams.get("wix_code");
    const wixCred: any = sessionStorage.getItem(LocalStorage.WIX_CRED);
    let loggedToken:any = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const loggedUserDetail:any =  jwtDecode(loggedToken);

    useEffect(() => {
        isAlreadyConnected();
    }, []);

    const isAlreadyConnected = async () => {
        const wixToken: any = jwtDecode(wix_shop ?? wixCred);
        const wixSite = wixToken.siteName;
        const endpoint = `common/v1/checkShop`;
        const payload={
            shopName:wixSite
        }

        await ConnectorService.post(endpoint,payload, '').then((response: any) => {
            console.log("response-----------------",response)
            if (response.statusCode === 200 &&  !_.isEmpty(response.result) && response.result.domainId !== loggedUserDetail.domainId) {
                notification.error({
                    message: "Sorry, This Store is already connected with Another worktual Account",
                    placement: "topRight",
                    duration: 7,
                    top: 70,
                });
                sessionStorage.removeItem(LocalStorage.WIX_CRED);
                navigate('/connectors');
            }
            else {
                sessionStorage.setItem(LocalStorage.WIX_CRED, wix_shop ?? wixCred );
                navigate('/wixconnection');
            }
        });
    };
    return (
        <>
            loading......
        </>
    )
};

export default WixStoreCheck;